import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const StyledBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '5px',
  h5: {
    fontSize: '18px',
    fontWeight: 'bold'
  },
  svg: {
    height: '16px'
  }
});



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpCollectedInfoBox/styles.js